module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "vrvr8p1j",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
    apiVersion: "2021-03-25",
  },
};
